function handleContent(contentId) {
    var contentSelector = '#' + contentId;
    var holderSelector = '.' + contentId + '__holder';

    function toggleContent() {
        jQuery(contentSelector).toggleClass('less');
        jQuery(holderSelector + ' .show-more-button, ' + holderSelector + ' .show-less-button').toggleClass('hidden-button');
    }

    if (jQuery(contentSelector).text().length > 332) {
        jQuery(contentSelector).addClass('less');
    }

    jQuery(holderSelector + ' .show-more-button, ' + holderSelector + ' .show-less-button').on('click keypress', function (event) {
        if (event.type === 'click' || (event.type === 'keypress' && event.which === 13)) {
            event.preventDefault();
            toggleContent();
        }
    });
}

jQuery(document).ready(function () {

    if( jQuery('.page-template-donate-form').length > 0 || jQuery('.page-template-other-ways-to-give').length > 0 ){
        handleContent('content1');
        handleContent('content2');
        // Add more content handling if needed

        // Set up an interval to check for the element every second
        var interval = setInterval(function() {
            // Check if the element with ID 'mongo-form' exists
            if (jQuery('#mongo-form').length) {
                // Element found, do something
                clearInterval(interval); // Stop the interval
                console.log('no more looking')
                jQuery('select.BBFormSelectList').select2({
                    width: '100%'
                })
                // Your code to handle the form goes here
            } else {
                console.log('still looking');
                // Element not found, continue checking
                // console.log('Mongo form not found yet.');
            }
        }, 1000); // Check every second (1000 milliseconds)
    }

});
